module.exports = __webpack_public_path__ + "yeni banyo dolabı 1.jpg?255558a4248641c1e2789f99bca84bc4";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni banyo dolabı 1.jpg
// module id = 380
// module chunks = 0